import React from "react";
import type { NodeProps } from "@xyflow/react";
import { KgDataModelNodeCard } from "../../../molecules/KgDataModelNodeCard";
import { KgFlowNodeHandles } from "./KgFlowNodeHandles";
import type { KgFlowNode } from "../types";

export const DataModelFlowNode: React.FC<NodeProps<KgFlowNode>> = ({
  data,
  selected,
}) => (
  <>
    <KgFlowNodeHandles />
    <KgDataModelNodeCard
      name={data.title ?? ""}
      collapsed={data.collapsed}
      visualState={data.visualState}
      isSelected={selected}
    />
  </>
);

export default DataModelFlowNode;
